<script setup lang="ts">
import type { Field } from "../types";
defineProps<{ fields: Field[]; width: number }>();
</script>
<template>
  <div class="bitfield-wrap">
    <div class="bit-numbers">
      <span>{{ width - 1 }}</span
      ><span>0</span>
    </div>
    <div class="bitfield" role="img" :aria-label="`${width}-bit register layout`">
      <span
        v-for="field in fields"
        :key="field.name"
        :style="{ left: `${(field.lsb / width) * 100}%`, width: `${(field.width / width) * 100}%` }"
        :title="`${field.name}: bits ${field.lsb + field.width - 1}:${field.lsb}`"
        >{{ field.name }}</span
      >
    </div>
  </div>
</template>
